import { isMobileBreakpoint, modifyLinkBehavior } from '../utils.js';
export default function masonryCards(widgetID, widgetOptions, numberOfCards) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (cards.length > 0) {
        modifyLinkBehavior(data, cards);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: isMobileBreakpoint ? ['all'] : [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: numberOfCards,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
  });
}
